import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { scrambleTextEffect, unscrambleTextEffect } from '@/views/situationRoom/animation';
export default {
  name: 'SiteList',
  props: {
    sites: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedIndex: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      scrambleControllers: [],
      unscrambleControllers: [],
      isCollapsing: false,
      isAnimating: false,
      pendingAnimation: null,
      isDestroyed: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      setTimeout(function () {
        _this.playListAnimation({
          mode: 'in'
        });
      }, 100);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.isDestroyed = true;
    this.cleanupAllAnimations();
  },
  watch: {
    sites: {
      handler: function handler() {
        var _this2 = this;
        if (this.isDestroyed) {
          return;
        }
        this.$nextTick(function () {
          _this2.playListAnimation({
            mode: 'in'
          });
        });
      },
      deep: true
    }
  },
  methods: {
    isDOMReady: function isDOMReady() {
      return this.$el && typeof this.$el.querySelectorAll === 'function';
    },
    waitForDOMAndRetry: function waitForDOMAndRetry(mode) {
      var _this3 = this;
      var maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
      if (this.isDestroyed) {
        return;
      }
      if (this.isDOMReady()) {
        this.playListAnimation({
          mode: mode
        });
        return;
      }
      if (maxRetries > 0) {
        setTimeout(function () {
          _this3.waitForDOMAndRetry(mode, maxRetries - 1, delay);
        }, delay);
      }
    },
    playListAnimation: function playListAnimation(_ref) {
      var mode = _ref.mode;
      if (this.isDestroyed) {
        return;
      }
      if (!this.isDOMReady()) {
        this.waitForDOMAndRetry(mode);
        return;
      }
      if (this.isAnimating) {
        this.pendingAnimation = {
          mode: mode
        };
        return;
      }
      this.isAnimating = true;
      if (mode === 'in') {
        this.playInAnimation();
      } else if (mode === 'out') {
        this.playOutAnimation();
      }
    },
    playInAnimation: function playInAnimation() {
      var _this4 = this;
      if (this.isDestroyed) {
        return;
      }
      this.cleanupAllAnimations();
      this.$nextTick(function () {
        var pList = _this4.$el.querySelectorAll('p');
        if (pList.length === 0) {
          _this4.isAnimating = false;
          _this4.checkPendingAnimation();
          return;
        }
        pList.forEach(function (p) {
          p.innerHTML = '';
        });
        pList.forEach(function (p, idx) {
          var _this4$sites$idx;
          var siteName = ((_this4$sites$idx = _this4.sites[idx]) === null || _this4$sites$idx === void 0 ? void 0 : _this4$sites$idx.name) || '';
          var paddedIndex = (idx + 1).toString().padStart(2, '0');
          var fullText = "".concat(paddedIndex, ". ").concat(siteName);
          var delayTime = idx * 200;
          setTimeout(function () {
            var controller = scrambleTextEffect(p, fullText, 600);
            _this4.scrambleControllers.push(controller);
          }, delayTime);
        });
        var totalDuration = (pList.length - 1) * 200 + 600;
        setTimeout(function () {
          if (!_this4.isDestroyed) {
            _this4.isAnimating = false;
            _this4.checkPendingAnimation();
          }
        }, totalDuration);
      });
    },
    playOutAnimation: function playOutAnimation() {
      var _this5 = this;
      if (this.isDestroyed) {
        return;
      }
      this.cleanupAllAnimations();
      this.$nextTick(function () {
        var pList = _this5.$el.querySelectorAll('p');
        if (pList.length === 0) {
          _this5.isAnimating = false;
          _this5.checkPendingAnimation();
          return;
        }
        pList.forEach(function (p, idx) {
          var _this5$sites$idx;
          var siteName = ((_this5$sites$idx = _this5.sites[idx]) === null || _this5$sites$idx === void 0 ? void 0 : _this5$sites$idx.name) || '';
          var paddedIndex = (idx + 1).toString().padStart(2, '0');
          var fullText = "".concat(paddedIndex, ". ").concat(siteName);
          var delayTime = idx * 100;
          setTimeout(function () {
            var controller = unscrambleTextEffect(p, fullText, 1500);
            _this5.unscrambleControllers.push(controller);
          }, delayTime);
        });
        var totalDuration = pList.length * 100 + 1500;
        setTimeout(function () {
          if (!_this5.isDestroyed) {
            _this5.isAnimating = false;
            _this5.$emit('list-collapsed');
            _this5.checkPendingAnimation();
          }
        }, totalDuration);
      });
    },
    checkPendingAnimation: function checkPendingAnimation() {
      if (this.isDestroyed) {
        return;
      }
      if (this.pendingAnimation) {
        var mode = this.pendingAnimation.mode;
        this.pendingAnimation = null;
        this.playListAnimation({
          mode: mode
        });
      }
    },
    cleanupAllAnimations: function cleanupAllAnimations() {
      this.scrambleControllers.forEach(function (controller) {
        var _controller$stop;
        return controller === null || controller === void 0 ? void 0 : (_controller$stop = controller.stop) === null || _controller$stop === void 0 ? void 0 : _controller$stop.call(controller);
      });
      this.scrambleControllers = [];
      this.unscrambleControllers.forEach(function (controller) {
        var _controller$stop2;
        return controller === null || controller === void 0 ? void 0 : (_controller$stop2 = controller.stop) === null || _controller$stop2 === void 0 ? void 0 : _controller$stop2.call(controller);
      });
      this.unscrambleControllers = [];
      this.isCollapsing = false;
      this.isAnimating = false;
      this.pendingAnimation = null;
    },
    initScrambleAnimation: function initScrambleAnimation() {
      this.playListAnimation({
        mode: 'in'
      });
    },
    initUnscrambleAnimation: function initUnscrambleAnimation() {
      this.playListAnimation({
        mode: 'out'
      });
    },
    selectSite: function selectSite(index, site) {
      this.$emit('site-selected', {
        index: index,
        site: site
      });
    }
  }
};